/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: DZI_ImageViewer_Quiz.js
 *  @description: Этот файл является частью клиентской стороны проекта. src Относится к части, которая содержит компоненты - части страниц, допускающие многократное использование в разных частях. DZI_OpenSeadragon DZI_ImageViewer_Quiz.js
 *	@author: Манжос Геннадий Юрьевич, Горбас Александр Петрович, Белов Михаил Александрович
*/
import React, { useState, useEffect } from "react";
import OpenSeadragon from "openseadragon";
import "./DZI_ImageViewer.css"

export const DZI_ImageViewer_Quiz = ({ images }) => {

    useEffect(() => {
        document.querySelectorAll('.openseadragon-container').forEach((e) => e.remove());

        OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "/openseadragon/images/",
            tileSources: images, // Передача массива путей к изображениям
            sequenceMode: true, // Включение режима последовательности
            showReferenceStrip: true, // Отображение горизонтальной полосы прокрутки
        });
    }, [images]);

    return <div className='openseadragon_dzi' id='openseadragon-viewer'></div>;
};

export default DZI_ImageViewer_Quiz;

/*
class DZI_ImageViewer_Quiz extends Component {
    

    componentDidMount() {
        console.log(`Mount`);
        console.log(this.props);

        const { images } = this.props;

        const viewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "/openseadragon/images/",
            tileSources: images, // Передача массива путей к изображениям
            sequenceMode: true, // Включение режима последовательности
            showReferenceStrip: true, // Отображение горизонтальной полосы прокрутки
        });
    }

    componentDidUpdate(prevProps, prevState) {
        console.log(`DidUpdate`);
        console.log(prevProps);
    }

    render() {
        console.log(`Render`);
        console.log(this.props);
        return <div className="openseadragon" id="openseadragon-viewer" />;
    }
}

export default DZI_ImageViewer_Quiz;
*/